<template>
  <div class="expo-service-container">
    <!-- <page-top></page-top> -->
    <!-- <div class="son-page"></div> -->
      <myImg
        img="https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner_7.png"
      ></myImg>
        <my-tab
        :tab-list="tabList"
        @change="changeTab"
        :activeIndex="activeIndex"
        :bread-title="breadTitle"
        smallSize
      ></my-tab>
    <div class="content_wrap container">

        <!-- <div class="menu_wrap">
          <div class="service_wrap">
            <div
              v-for="(item,index) in tabList"
              :key="index"
              :class="[{'act-item':activeIndex==index},'media_font_size_50']"
              @click="activeIndex=index"
            >{{item.title}}</div>
          </div>
          <div class="right_wrap" :style="{'fontSize':'14px'}">
            当前位置：
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>展商</el-breadcrumb-item>
              <el-breadcrumb-item>{{tabList[activeIndex].title}}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div> -->
        <attact v-if="activeIndex==0" />
        <home-service v-if="activeIndex==1" />
        <exhibit-book v-if="activeIndex==2" />
        <exhibit-map v-if="activeIndex==3" />
        <exhibit-data v-if="activeIndex==4" />
    </div>
    <!-- <page-bottom></page-bottom> -->
        <page-footer></page-footer>
  </div>
</template>

<script>
import pageTop from "@/components/pageTop";
// import pageBottom from "@/components/pageBottom";
import attact from "./components/attact";
import exhibitBook from "./components/exhibitBook";
import exhibitData from "./components/exhibitData";
import exhibitMap from "./components/exhibitMap";
import homeService from "./components/homeService";
import myTab from "@/components/myTab";
import myImg from "@/components/myImg";
import pageFooter from "@/components/pageFooter"

export default {
  components: {
    pageTop,
    // pageBottom,
    attact,
    exhibitBook,
    exhibitMap,
    homeService,
    exhibitData,
    myTab,
    myImg,
    pageFooter
  },
  data() {
    return {
      activeIndex: 0,
      tabs:this.$route.query.tab,
      tabList: [
        {
          title:this.$t("exhibitors.invitation"),
          en:"Invitation",
        },
        {
          title:this.$t("exhibitors.service"),
          en:"Service",
        },
        {
          title:this.$t("exhibitors.manual"),
          en:"Exhibitor's Manual",
        },
        {
          title:this.$t("exhibitors.pavilion"),
          en:"Pavilion",
        },
        {
          title:this.$t("exhibitors.download"),
          en:"Download",
        }
      ],
      breadTitle:{
        cn:this.$t("exhibitors.title"),
        en:"Exhibitor"
      },
      metroList: [
        {
          line: "8号",
          station: "新港东、琶洲",
          start: "凤凰新村←→万胜围",
          time: "06:15-22:40",
          fee: "6元"
        }
      ],
      busList: [
        {
          line: "137",
          station: "琶洲、琶洲大桥南",
          start: "动物园南门(总站)←→新洲总站",
          time: "06:15-21:45",
          fee: "2元"
        },
        {
          line: "139",
          station: "琶洲、国际会展中心",
          start: "东圃客运站(总站)←→海珠客运站总站",
          time: "06:15-22:00",
          fee: "3元"
        },
        {
          line: "20",
          station: "琶洲、琶洲大桥南、国际会展中心",
          start: "岑村教练场总站←→赤岗大塘(总站)",
          time: "06:00-22:00",
          fee: "2元"
        },
        {
          line: "229",
          station: "琶洲、琶洲大桥南、国际会展中心",
          start: "罗冲围总站←→琶洲石基村总站",
          time: "06:00-22:00",
          fee: "2元"
        },
        {
          line: "262",
          station: "琶洲、琶洲大桥南、国际会展中心",
          start: "赤岗东(总站) ←→ 新洲总站",
          time: "05:50-22:30",
          fee: "2元"
        },
        {
          line: "507",
          station: "琶洲、琶洲大桥南、国际会展中心",
          start: "大学城总站←→黄埔区政府",
          time: "06:00-21:30",
          fee: "3元"
        },
        {
          line: "564",
          station: "琶洲、琶洲大桥南",
          start: "琶洲黄埔村总站←→天河客运站(总站)",
          time: "06:30-21:30",
          fee: "4元"
        },
        {
          line: "583",
          station: "琶洲、琶洲大桥南、国际会展中心",
          start: "逸景翠园总站←→车陂(总站)",
          time: "06:30-21:00",
          fee: "2元"
        },
        {
          line: "92",
          station: "琶洲、国际会展中心",
          start: "广州火车东站总站←→江海大道中",
          time: "06:30-22:00",
          fee: "2元"
        },
        {
          line: "大学城3线",
          station: "琶洲、琶洲大桥南、国际会展中心",
          start: "大学城总站←→广东药学院总站",
          time: "07:30-22:00",
          fee: "3元"
        },
        {
          line: "505",
          station: "琶洲、琶洲大桥南、国际会展中心",
          start: "塘村总站←→珠江泳场总站",
          time: "06:30-21:30",
          fee: "3元"
        }
      ],
      downList: [
        {
          title: "2021广州车展招商手册",
          url: ""
        },
        {
          title: "2021广州车展投标文件",
          url: ""
        }
      ],
      serviceList: [
        {
          dates: "2021年11月19日（星期五）",
          times: "9:00-17:30",
          tips: "媒体日、仅限媒体"
        },
        {
          dates: "2021年11月20日-21日（星期六-星期天）",
          times: "9:00-17:30",
          tips: "仅限专业观众"
        },
        {
          dates: "2021年11月22日-28日（星期一-星期天）",
          times: "9:00-17:30",
          tips: "对公众和专业观众开放"
        }
      ]
    };
  },
  watch: {
    $route(to, from) {
      //监听路由是否变化
      if (to.query.tab != from.query.tab) {
        this.changeTabs(to.query.tab);
      }
    }
  },
  mounted(){
    this.changeTabs(this.tabs)
  },
  methods: {
    changeTab(){

    },
    changeTabs(index) {
      this.activeIndex = index;
    }
  }
};
</script>

<style lang="scss">
.expo-service-container {
  width: 100vw;
  // height: 2000px;
  min-height: 100vh;
  background: #221f26;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // justify-content: space-between;
  .content_wrap {
    // display: flex;
    // flex-direction: column;
    // align-items: center;
    // flex:auto;
    // justify-content: space-between;
    margin-top:100px;
    margin-bottom: 100px;
  }
  .son-page {
    width: 1920px;
    height: 300px;
    background-image: url("https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner_7.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .menu_wrap {
    width: 1200px;
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 60px;
    .service_wrap {
      height: 100px;
      border-bottom: 1px solid rgba($color: #fff, $alpha: 0.2);
      box-sizing: border-box;
      display: flex;
      > div {
        font-size: 24px;
        line-height: 100px;
        text-align: center;
        color: #ccc;
        border-bottom: 2px solid transparent;
        margin-right: 30px;
      }
      .act-item {
        color: #42abff;
        border-bottom: 1px solid #42abff;
      }
    }
    .right_wrap {
      display: flex;
      color: rgba(255, 255, 255, 0.8);
      align-items: center;
    }
  }
  .service_detail {
    width: 1200px;
    margin: 60px 0px;
    color: #fff;
    > h1 {
      font-size: 44px;
    }
    > span {
      color: rgba(255, 255, 255, 0.5);
      font-size: 24px;
    }
  }
  .data_detail {
    margin: 60px 0px;
    .data_item {
      width: 1200px;
      height: 120px;
      background: rgba($color: #fff, $alpha: 0.2);
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0px 30px;
      box-sizing: border-box;
      margin-bottom: 30px;
      > span {
        font-size: 36px;
        color: #fff;
      }
      > div {
        // width: 200px;
        padding: 5px 20px;
        // height: 60px;
        background: #42abff;
        border-radius: 30px;
        font-size: 24px;
        color: #fff;
        // line-height: 65px;
        text-align: center;
      }
    }
  }
  .traffic_detail {
    margin: 60px 0px;
    .traffic_item {
      width: 1200px;
      .traffic_type {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        > div {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: #e16a13;
          color: #fff;
          margin-right: 17px;
          text-align: center;
          font-weight: bold;
          line-height: 36px;
          font-size: 20px;
        }
        > span {
          font-size: 30px;
          color: #fff;
        }
      }
    }
  }
  .header-row {
    background: #42abff !important;
    color: #fff;
    text-align: center !important;
  }
}
.mb_80 {
  margin-bottom: 80px;
}

@media screen and (max-width: 1000px) {
  .expo-service-container {
    .content_wrap {
      .menu_wrap {
        width: 100vw;
        height: 200px;
        justify-content: center;
        .about_wrap {
          // width: 100%;
          // height: 200px;
        }
        .right_wrap {
          display: none;
        }
      }
      .data_detail {
        // width: 100vw;
        .data_item {
          // width: 100vw;
          height: 300px;
          > div {
          }
        }
      }
    }
  }
}
</style>

<style>
.service-container .el-breadcrumb__item .el-breadcrumb__inner {
  color: rgba(255, 255, 255, 0.8) !important;
}
</style>


// WEBPACK FOOTER //
// index.vue?fbbada20